module.exports = __webpack_public_path__ + "static/media/70.1ddc4454.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/70.jpg
// module id = 1008
// module chunks = 0